import { render } from "./pie.html?vue&type=template&id=722b0e7a&scoped=true&ts=true"
import script from "./pie.ts?vue&type=script&lang=ts"
export * from "./pie.ts?vue&type=script&lang=ts"

import "./pie.scss?vue&type=style&index=0&id=722b0e7a&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722b0e7a"]])

export default __exports__